"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserUtils = void 0;
const user_1 = require("../types/user");
class UserUtils {
    static isGlobalAdmin(user) {
        return user?.roles?.some((role) => role.name === user_1.RoleName.GLOBAL_ADMIN) ?? false;
    }
    /**
     * Ask and the Gate AI tab. The assigned role is the one the client
     * receives. Global Administrator is stronger than Organization Administrator.
     */
    static canUseStaffAssistant(user) {
        return (user?.roles?.some((role) => role.name === user_1.RoleName.GLOBAL_ADMIN || role.name === user_1.RoleName.ORG_ADMIN) ?? false);
    }
}
exports.UserUtils = UserUtils;
